import React from "react";
import { Modal, RadioGroup, Spinner } from "react-rainbow-components";
import {
  ButtonContainer,
  ButtonCreateAdmin,
  InputAdmin,
  InputLabel,
  InputTextArea,
  Title,
} from "../common/FormComponent";
import { createCoupon } from "../../services/coupon.service";

import { useError } from "../../store/ErrorModal";

interface Props {
  isOpen: boolean;
  onRequestClose?: () => void;
  fetchData?: () => void;
}
const ModalCreateCoupon = (props: Props) => {
  const options = [
    { value: "chat", label: "แชท" },
    { value: "video", label: "วีดีโอคอล" },
  ];
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [valueGroupButton, setValueGroupButton] = React.useState<string>(
    options[0].value
  );
  const [data, setData] = React.useState<{ [key: string]: any }>({
    type: options[0].value,
  });
  const { onError } = useError();
  const handleChangeData = (key: string, value: string | number) => {
    const nData = data;
    nData[key] = value;
    return setData(nData);
  };

  const handleCreateCoupon = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    setIsLoading(true);
    if (
      !data.productName ||
      !data.timeRange ||
      !data.type ||
      !data.productDescription
    ) {
      setIsLoading(false);
      handleCloseModal();
      return onError("กรุณากรอกข้อมูลให้ครบ");
    }
    try {
      await createCoupon(data);
      handleCloseModal();
      setIsLoading(false);
      return props.fetchData && props.fetchData();
    } catch (error) {
      setIsLoading(false);
      return onError(error as any);
    }
  };

  const handleCloseModal = () => {
    setData({
      type: data.type,
    });
    props.onRequestClose && props.onRequestClose();
  };

  return (
    <Modal
      hideCloseButton
      isOpen={props.isOpen}
      onRequestClose={handleCloseModal}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <form
          style={{ display: "flex", flexDirection: "column" }}
          onSubmit={handleCreateCoupon}
        >
          <Title>สร้างคูปอง</Title>
          <InputLabel>ชื่อคูปอง</InputLabel>
          <InputAdmin
            placeholder="ชื่อคูปอง"
            onChange={(e: React.ChangeEvent<{ value: string }>) =>
              handleChangeData("productName", e.target.value)
            }
          />
          <InputLabel>รายละเอียด</InputLabel>
          <InputTextArea
            placeholder="รายละเอียด"
            onChange={(e: React.ChangeEvent<{ value: string }>) =>
              handleChangeData("productDescription", e.target.value)
            }
          />
          <ButtonContainer>
            <InputLabel>ประเภท</InputLabel>
          </ButtonContainer>
          <ButtonContainer>
            <RadioGroup
              id="radio-group-component-1"
              options={options}
              value={valueGroupButton}
              onChange={(e: React.ChangeEvent<{ value: string }>) => {
                setValueGroupButton(e.target.value);
                handleChangeData("type", e.target.value);
              }}
              orientation="horizontal"
            />
          </ButtonContainer>
          <InputLabel>
            ระยะเวลา{" "}
            {valueGroupButton === options[1].value ? "(นาที)" : "(วัน)"}
          </InputLabel>
          <InputAdmin
            type="number"
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              let value = +e.target.value;
              let dayRange = 1;
              if (valueGroupButton === options[0].value) {
                dayRange = value;
                value = value * 1440;
              }
              handleChangeData("timeRange", value);
              handleChangeData("dayRange", dayRange);
            }}
            placeholder={`ระยะเวลา ${
              valueGroupButton === options[1].value ? "(นาที)" : "(วัน)"
            }`}
          />
          <ButtonContainer>
            <ButtonCreateAdmin value="สร้างคูปอง" />
          </ButtonContainer>
        </form>
      )}
    </Modal>
  );
};

export default ModalCreateCoupon;
